// extracted by mini-css-extract-plugin
export default {"container":"button_container__jPndU","primary":"button_primary__ZBQkr","inverted":"button_inverted__NLWOd","disabled":"button_disabled__nknnF"};